import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../../store/actions'
import moment from 'moment'
import Input from '../../../../../module/input'
import Calendar from '../../../../../module/component-box/Calendar'
/*import Calendar from '../../../../../module/calendar'*/
import { commons } from '../../../../../hook/common'
import * as common from '../../../../../assets/js/common.js'

/**
 * 세금계산서 등록/수정 팝업
 * @param props
 * @constructor
 */
const PopTax = (props) => {
  const nodeBaseInfo = {
    taxNo: {
      title: '세금계산서 번호',
      type: 'text',
      length: 11,
      required: true,
      message: '세금계산서번호를 입력해주세요.',
    },
    itemCd: {
      title: '제품코드',
      type: 'text',
      length: 20,
    },
    itemnm: {
      title: '품명',
      type: 'text',
      length: 35,
      required: true,
      readOnly: true,
      itemnm: false,
      className: 'form-keyword col',
      message: '품명을 선택해주세요.',
      placeholder: "'구매 물품 목록'에서 입력한 제품을 선택합니다.",
    },
    /* itemdeftxt: {
      title: '규격',
      type: 'text',
      length: 70,
    }, */
    splyAmt: {
      title: '공급가액',
      type: 'number',
      required: true,
      message: '공급가액을 입력해주세요.',
    },
    taxAmt: {
      title: '세액',
      type: 'number',
      required: true,
      message: '세액을 입력해주세요.',
    },
    itemqty: {
      title: '수량',
      type: 'number',
      required: true,
      message: '수량을 입력해주세요.',
    },
    itemqtyunitcd: {
      title: '수량코드',
      type: 'text',
    },
    writedt: {
      title: '작성일자',
    },
  }

  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))
  const [state, setState] = useState({})
  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const [reset, setReset] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editIdx, setEditIdx] = useState(false)
  const [itemList, setItemList] = useState(props.stepData)
  const [itemInput, setItemInput] = useState({})
  const [selectItems, setSelectItems] = useState([])

  /**
   * 화면집입시 초기값 세팅
   */
  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step4
    commons.preventKeyDown()
    setItemList(list)
    setItemInput({ seq: list.length + 1 })
  }, [])

  /**
   * 데이터 저장 후 입력폼 갱신
   */
  useEffect(() => {
    if (props.isCalled === true) {
      setItemList(props?.stepData)
      newInput()
      setReset(true)
    }
    props.setCalled(false)
  }, [props?.isCalled])

  /**
   * input 갱신을 위한 hook
   */
  useEffect(() => {
    if (reset === true) setReset(false)
  }, [reset])

  /**
   * 물품목록 선택팝업 콜백
   */
  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step2
    let item = list?.filter((item) => {
      return item.crtItemSeq === props.selectItemSeq
    })[0]

    item &&
      setItemInput({
        ...itemInput,
        hsCd: item?.hsCd,
        itemnm: item?.itemnm,
        itemdeftxt: item?.itemdeftxt,
        splyAmt: item?.baseAmt,
        taxAmt: parseInt(item?.baseAmt) * 0.1,
      })
  }, [props.selectItemSeq])

  /**
   * 입력학목 유효성 체크 및 저장 api 호출
   */
  const saveItem = () => {
    setState({ ...state, submitted: !state.submitted, errWritedt: '' })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (!itemInput?.[key] || itemInput?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        //console.log(index)
        if (node.itemnm.itemnm) {
          inputRef.current[index].focus()
        }
        //inputRef.current[index].focus()
      }
    })

    if (!itemInput.writedt || itemInput.writedt?.length <= 0) {
      setState({ ...state, errWritedt: '작성일자를 선택해주세요.' })
      errCnt++
    }

    if (errCnt > 0) return

    props.saveStep(props.docid, '4', itemInput, isEdit)
  }

  /**
   * 물품정보 수정
   * @param seq
   */
  const selectEdit = (crtTaxSeq, index = -1) => {
    if (editIdx === index) {
      newInput()
    } else {
      setItemInput({ ...itemList[itemList.findIndex((item) => item.crtTaxSeq === crtTaxSeq)] })
      setIsEdit(true)
      setEditIdx(index)
    }
  }

  /**
   * 새로작성
   */
  const newInput = () => {
    setState({ ...state, errWritedt: '' })
    let node = nodeInfo
    Object.keys(node).forEach((key, index) => {
      node[key].errMessage = null
    })

    setSelectItems([])
    setItemInput({})
    setIsEdit(false)
    setEditIdx(-1)
    setReset(true)
  }

  /**
   * 선택삭제
   * @returns {*}
   */
  const deleteItems = () => {
    if (selectItems?.length <= 0) {
      return props.error({ message: '삭제할 물품을 선택해주세요.' })
    }

    props.confirm({
      title: '확인',
      message: '정말 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.deleteStepItems(props.docid, '4', selectItems)
        },
      },
    })
  }

  /**
   * 전체삭제
   */
  const deleteAll = () => {
    itemList?.length > 0 &&
      props.confirm({
        title: '확인',
        message: '정말 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.deleteStepItemAll(props.docid, '4')
          },
        },
      })
  }

  const handleClose = () => {
    props.onClose()
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setItemInput({
      ...itemInput,
      [name]: value,
    })
  }

  const onSelectItem = (e) => {
    const { name, checked } = e.target
    let list = selectItems
    if (checked) {
      list.push(name)
    } else {
      list = selectItems.filter((item) => item !== name)
    }
    setSelectItems(list)
  }

  const generateInput = (key) => {
    const node = nodeInfo[key]
    let idx = Object.keys(nodeBaseInfo).findIndex((objKey) => objKey === key)
    let className = ''
    let wrapperClassName = node?.wrapperClassName
    let maxLength = node.length
    !maxLength && node?.type === 'number' && (className += 'right ')
    !maxLength && node?.type === 'number' && (maxLength = 16)

    return (
      <Input
        id={key}
        name={key}
        type={node.type}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        value={itemInput?.[key] || ''}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={wrapperClassName}
        className={className + node?.className}
        placeholder={node?.placeholder}
        message={node?.message}
        onChange={handleChange}
        readOnly={node.readOnly}
        required={node.required}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        length={maxLength}
        errMessage={node.errMessage}
      />
    )
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '1',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '2',
    display: 'block',
  }

  return (
    <React.Fragment>
      {/* 세금계산서 등록 / 수정 */}
      <div style={style}></div>
      <div style={styleModal} id="tax-register" className="modal w1120">
        <div className="modal-head">
          <h2>세금계산서 정보 등록</h2>
        </div>
        <div className="modal-cont">
          <table className="tbl-write">
            <caption>세금계산서번호, 품명/규격, 공급가액, 세액, 수량, 작성일자 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col className="col2" />
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 세금계산서번호
                </th>
                <td colSpan={3}>{generateInput('taxNo')}</td>
                {/* 
                <th scope="row">제품코드</th>
                <td>{generateInput('itemCd')}</td>
                */}
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 품명/규격
                </th>
                <td colSpan={3}>
                  <span className="input-group full">
                    {generateInput('itemnm')}
                    {/*  <input
                      type="text"
                      id="itemnm"
                      title="품명"
                      name="itemnm"
                      className="form-keyword col2"
                      placeholder="'구매 물품 목록'에서 입력한 제품을 선택합니다."
                      readOnly
                      value={itemInput?.['itemnm'] || ''}
                    /> */}
                    {common.getDeviceType() !== 'MobileApp' ? (
                      <a
                        href="#"
                        className="btn-secondary sm"
                        onClick={(e) => {
                          e.preventDefault()
                          props.isShowItems(true)
                        }}
                      >
                        구매물품선택
                      </a>
                    ) : (
                      <a
                        href="#"
                        className="btn-secondary sm"
                        onClick={(e) => {
                          e.preventDefault()
                          props.isShowItems(true)
                        }}
                      >
                        선택
                      </a>
                    )}
                    <input
                      type="text"
                      id="itemdeftxt"
                      title="규격"
                      name="itemdeftxt"
                      className="form-keyword col2"
                      placeholder="'구매 물품 목록'에서 입력한 제품을 선택합니다."
                      readOnly
                      value={itemInput?.['itemdeftxt'] || ''}
                    />
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 공급가액
                </th>
                <td>
                  <span className="input-group full">{generateInput('splyAmt')}</span>
                </td>
                <th scope="row">
                  <em className="required" /> 세액
                </th>
                <td>
                  <span className="input-group full">{generateInput('taxAmt')}</span>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 수량
                </th>
                <td>
                  <span className="input-group full">
                    {generateInput('itemqty')}
                    <select
                      id="itemqtyunitcd"
                      name="itemqtyunitcd"
                      title={'수량코드'}
                      className="form-category w120"
                      value={itemInput.itemqtyunitcd || ''}
                      onChange={handleChange}
                    >
                      <option value="">수량코드</option>
                      <option value="EA">EA</option>
                      <option value="PC">PC</option>
                      <option value="KG">KG</option>
                      <option value="CT">CT</option>
                      <option value="YD">YD</option>
                      <option value="M">M</option>
                      <option value="SET">SET</option>
                      <option value="MT">MT</option>
                      <option value="BOX">BOX</option>
                      <option value="RO">RO</option>
                      <option value="UN">UN</option>
                      <option value="PR">PR</option>
                      <option value="SF">SF</option>
                      <option value="M2">M2</option>
                      <option value="LO">LO</option>
                    </select>
                  </span>
                </td>
                <th scope="row">
                  <em className="required" /> 작성일자
                </th>
                <td>
                  {reset === false && (
                    <span className="datepicker">
                      <Calendar
                        default={itemInput.writedt && moment(itemInput.writedt, 'YYYYMMDD').format('YYYY-MM-DD')}
                        onSelect={(value) =>
                          setItemInput({
                            ...itemInput,
                            writedt: moment(value).format('YYYYMMDD'),
                          })
                        }
                      />
                    </span>
                  )}
                  {state.errWritedt && <span className="txt">{state.errWritedt}</span>}
                </td>
              </tr>
            </tbody>
          </table>
          <div className="btn-block center">
            <a
              href="#"
              className="btn-secondary md"
              onClick={(e) => {
                e.preventDefault()
                newInput()
              }}
            >
              새로작성
            </a>
            <a
              href="#"
              className="btn-primary md"
              onClick={(e) => {
                e.preventDefault()
                saveItem()
              }}
            >
              {isEdit === true ? '수정' : '저장'}
            </a>
          </div>
          <div className="list-header">
            <span className="total-num">총 {itemList?.length}건</span>
            <span className="right">
              <a
                href="#"
                className="btn-secondary sm"
                onClick={(e) => {
                  e.preventDefault()
                  deleteItems()
                }}
              >
                선택삭제
              </a>
              <a
                href="#"
                className="btn-secondary sm"
                onClick={(e) => {
                  e.preventDefault()
                  deleteAll()
                }}
              >
                전체삭제
              </a>
            </span>
          </div>
          <div className="tbl-wrap">
            <table className="tbl-list">
              <caption>선택, 세금계산서번호, 품명, 규격, 공급가액, 세액, 수량, 선적기일 항목으로 구성</caption>
              <colgroup>
                <col style={{ width: '7%' }} />
                <col style={{ width: '13%' }} />
                <col style={{ width: '24%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '11%' }} />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">선택</th>
                  <th scope="col">세금계산서번호</th>
                  <th scope="col">품명</th>
                  <th scope="col">규격</th>
                  <th scope="col">공급가액</th>
                  <th scope="col">세액</th>
                  <th scope="col">수량</th>
                  <th scope="col">작성일자</th>
                </tr>
              </thead>
              <tbody>
                {itemList?.length > 0 ? (
                  itemList?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="cell">
                          <input type="checkbox" title={'checkbox' + index} name={item.crtTaxSeq} onChange={onSelectItem} />
                          <em />
                        </td>
                        <td className="cell" data-title={'세금계산서번호'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {item.taxNo}
                        </td>
                        <td className="cell" data-title={'품명'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {item.itemnm}
                        </td>
                        <td className="cell" data-title={'규격'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {item.itemdeftxt}
                        </td>
                        <td className="cell" data-title={'공급가액'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {commons.addComma(item.splyAmt)}
                        </td>
                        <td className="cell" data-title={'세액'} onClick={() => selectEdit(item.crtTaxSeq, index)}>
                          {commons.addComma(item.taxAmt)}
                        </td>
                        <td className="cell" data-title={'수량'}>
                          {item?.itemqty && commons.addComma(item.itemqty)} {item?.itemqtyunitcd}
                        </td>
                        <td className="cell" data-title={'작성일자'}>
                          {moment(item.writedt).format('Y-M-D')}
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={8}>
                      <div className="nodata">등록된 자료가 없습니다.</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <button type="button" className="modal-close b-close" onClick={handleClose}>
          창닫기
        </button>
      </div>
      {/* 구매물품 목록 등록/수정 */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.certapply?.data?.step4,
    isCalled: state.certapply.isCalled,
    selectItemSeq: state.certapply.itemSeq,
  }
}

const actionCreators = {
  saveStep: certapplyActions.saveStep,
  setCalled: certapplyActions.setCalled,
  error: alertActions.error,
  confirm: alertActions.confirm,
  deleteStepItems: certapplyActions.deleteStepItems,
  deleteStepItemAll: certapplyActions.deleteStepItemAll,
  isShowItems: certapplyActions.isShowItems,
}

export default connect(mapStateToProps, actionCreators)(PopTax)
